<template>
  <div>
    <div id="left1">
      <user-model></user-model>
      <div id="hide" class="gray"></div>
    </div>
    <div id="middle1"></div>
    <div v-show="show" id="right1">
      <el-button @click="exam">test1</el-button>
    </div>
    <div id="left-11" v-show="!show">
      <el-button @click="exam2">test2</el-button>
    </div>
  </div>
</template>

<script>
import userModel from "@/views/user/userViewModel.vue";
export default {
  data() {
    return {
      show: false
    };
  },
  components: { userModel },
  mounted() {
    function $(id) {
      return document.getElementById(id);
    }
    var left = $("left1"),
      hide = $("hide"),
      right = $("right1"),
      middle = $("middle1");
    var middleWidth = 2;
    middle.onmousedown = function(e) {
      hide.style.display = "block";
      var disX = (e || event).clientX;
      middle.left = middle.offsetLeft;
      document.onmousemove = function(e) {
        var iT = middle.left + ((e || event).clientX - disX);
        var e = e || window.event,
          tarnameb = e.target || e.srcElement;
        var maxT = document.body.clientWidth;
        iT < 150 && (iT = 150);
        iT > maxT - 150 && (iT = maxT - 150);
        middle.style.left = left.style.width = iT + "px";
        hide.style.width = left.style.width = iT + "px";
        right.style.width = document.body.clientWidth - iT - middleWidth + "px";
        right.style.left = iT + middleWidth + "px";
        return false;
      };
      document.onmouseup = function() {
        hide.style.display = "none";
        document.onmousemove = null;
        document.onmouseup = null;
        middle.releaseCapture && middle.releaseCapture();
      };
      middle.setCapture && middle.setCapture();
      return false;
    };
  },
  created() {},
  watch: {},
  methods: {
    exam() {
      this.show = false;
      $("#left1").css("width", "100%");
    },
    exam2() {
      this.show = true;
      // $("#left1").css("width", "50%");
      // $("#hide").css("width", "50%");
      // $("#right1").css("width", "50%");
      // $("#middle1").css("left", "50%");
    }
  }
};
</script>

<style scoped lang="less">
#middle1 {
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  border-left: 18px dashed transparent;
  margin-left: -9px;
  cursor: e-resize;
}
//修改
#left1 {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 1;
  background: red;
}
#right1 {
  width: 50%;
  height: 100vh;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1;
  left: inherit;
  background: green;
}
#left-11 {
  width: 461.4px;
  height: 350.4px;
  position: absolute;
  right: 20px;
  top: 14%;
  z-index: 1;
  background: skyblue;
}
</style>
